import { useState, useEffect } from 'react';
import Button from "@material-ui/core/Button";
import { makeStyles, ButtonGroup, Grid, TextField, InputAdornment, SvgIcon, Dialog, DialogTitle, DialogContent, Box, Divider, Container, Typography  } from "@material-ui/core";
import { Search as SearchIcon } from 'react-feather';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { getAdminUsers, getRoles, updateUserRoles, deletePermanentUser} from "../../../../store/actions/admin/user";
import { useSelector, useDispatch } from 'react-redux';
import ViewUser from './viewUser';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import EmailIcon from '@material-ui/icons/EmailOutlined';
import UserModel from './userModel';
import EditUserModel from './editUserModel';
import UtilService from "../../../../helper/service";
import { ResendLink } from '../../../../store/actions';
import CustomSnackBar from '../../creator/experienceManager/participantsDashboard/component/CustomSnackBar';
import AdminTable from './AdminTable';
import {Loading} from '../../../atoms/commonLoadings';
import Config from "../../../../config/config";


const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(3),
  },
  description:{
    font: "normal normal bold 24px/26px Spartan-bold",
    color: "#697683",
    
    opacity: "1",
    margin:"10px 0 30px 0",
    '@media (max-width: 559px)': {
      textAlign:"center",
      margin: "10px 0 10px 0"
    },
  },
  icon: {
    marginRight: -10,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  tagmodalwrap: {
    margin: 'auto',
    maxWidth: 500,
    borderRadius: 14,
  },
  delemaildesc: {
    fontFamily: 'roboto-regular',
    fontSize: 14,
    color: '#697683'
  },
  modalBtn: {
    width: 80,
    height: 36,
    fontFamily: 'roboto-regular',
    textTransform: 'none',
    fontSize: 16,
    marginLeft: 14,
  },
}));

export default function List() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [newrows, setNewrows] = useState([]);
  const [columns, setNewcolumns] = useState([]);
  const { roles, users } = useSelector((state: any) => state.adminUser);
  const { success } = useSelector((state: any) => state.notification);
  const [showViewModal, setShowViewModal] = useState(false);
  const [firstName, setFirstname] = useState("");
  const [lastName, setLastname] = useState("");
  const [userId, setuserId] = useState("");
  const { is_loading } = useSelector((state: any) => state.experience);
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setEditShowModal] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [snackAlertType, setSnackAlertType] = useState("success");
  const [snackAlertMsg, setSnackAlertMsg] = useState("");
  const [isShownSnackAlert, setIsShownSnackAlert] = useState(false);

  const [confirmationDeletePage,setConfirmationDeletePage] = useState(false);
  const [deleteuserdata, setdeleteuser] = useState<any>()
  const admin_roleid = roles ? roles.filter((val:any) => val.role_name === "admin")[0] : {role_id: "0"};
  const creator_roleid = roles ? roles.filter((val:any) => val.role_name === "creator")[0] : {role_id: "0"};
  const subscriber_roleid = roles ? roles.filter((val:any) => (val.role_name === "subscriber" || val.role_name === "subscriberclever" || val.role_name === "subscribersmart" || val.role_name === "subscribergenius")) : [{role_id: "0"}];
  
  const isuseradmin = (loginUserData && loginUserData.role_access) ? loginUserData.role_access.filter((val:any) => val.access_name === "admin_users") : null;
  const isusertrialadmin = (loginUserData && loginUserData.role_access) ? loginUserData.role_access.filter((val:any) => val.access_name === "trial_admin") : null;
  const system_flagged = loginUserData ? loginUserData.system_flagged : false;
  
  const editUserDetail = (value: any) => {
    setuserId(value.id);
    setFirstname(value.first_name);
    setLastname(value.last_name);
    setEditShowModal(true);
  }

  //Close model
  const closeModal = () => {
    setShowViewModal(false);
    setShowModal(false);
    setEditShowModal(false);
  };

  // when change users role
  const handleChangeRole = (event: any, value: any) => {
    event.stopPropagation();
    if (event.target.value) {
      const request = {
        customer_name: loginUserData.customer_name,
        role_id: event.target.value,
        user_id: value.id
      }
      dispatch(updateUserRoles(apolloClient.client, request));
    }
  }

  //when resendEmail 
  const resendEmail = (event: any, value: any) => {
    event.stopPropagation();
    const request = {
      email: value.username,
      brand: Config.DEFAULT_SUBBRAND,
    };
    dispatch(ResendLink(apolloClient.client, request));
  }

  useEffect(() => {
    
    if(success){
      if(success == true){
        setSnackAlertMsg("Email sent sucessfully.");
        setIsShownSnackAlert(true);
      } else {
        setSnackAlertType("error");
        setSnackAlertMsg("Problem occured while send email.");
        setIsShownSnackAlert(true);  
      }
    }
  }, [success]);


  useEffect(() => {
    const userFiled: any = [];
    let colsfields: any = [];

    if(roles && roles.length && users){
      colsfields = [
        {
          field: "first_name", headerName: "First Name", width: 120, renderCell: (params: any) => {
            return params.row.first_name ? params.row.first_name : "-"
          }
        },
        {
          field: "last_name", headerName: "Last Name", width: 120, renderCell: (params: any) => {
            return params.row.last_name ? params.row.last_name : "-"
          }
        },
        {
          field: "username", headerName: "Email", width: 200, renderCell: (params: any) => {
            return params.row.username ? params.row.username : "-"
          }
        },
        {
          field: "role_id", headerName: "Role", width: 130, sortable: false, renderCell: function Role(params: any){
            return (<Select
              labelId="select-role"
              id="select-role"
              value={params.row.role_id ? params.row.role_id : null}
              onChange={(event: any) => handleChangeRole(event, params)}
            >
              {roles && roles.length > 0 ?
                roles.map((val: any, index: any) => {
                  return (
                      (isuseradmin && isuseradmin[0].access_value) ?
                        (
                          (val.role_id == admin_roleid.role_id || val.role_id == creator_roleid.role_id) &&
                            <MenuItem key={index} value={val.role_id}>{val.role_description}</MenuItem>
                        )
                      :  (isusertrialadmin && isusertrialadmin[0].access_value) ?
                        (
                          (val.role_id == loginUserData.role_id ||  subscriber_roleid.filter((v:any) => v.role_id == val.role_id)[0]) &&
                            <MenuItem key={index} value={val.role_id}>{val.role_description}</MenuItem>
                        )
                      :
                      <></>
                  )
                })
                :
                <MenuItem value={0}>No any tenant</MenuItem>
              }
            </Select>)
          }
        },
        {
          field: "experience", headerName: "Experiences", width: 130, renderCell: (params: any) => {
            return params.row.experience ? params.row.experience : "-"
          }
        },
        {
          field: "last_active", headerName: "Last Active", width: 200, renderCell: (params: any) => {
            return params.row.last_active ? params.row.last_active : "-"
          }
        },
        {
          field: "id", headerName: "Action", width: 100, sortable: false, renderCell: function Action(params: any) {
            return <ButtonGroup size="small" >
              <Button
                type="button"
                title="Reset Password"
                style={{border:"none",color:"#717E8B",minWidth:'15px',padding:"5px"}}
                onClick={
                  () => editUserDetail(params)
                }
              ><i className="icon-pencil" style={{fontSize:"14px"}}></i> </Button>
               <Button
                type="button"
                title="Reset Password"
                style={{border:"none",color:"#717E8B",minWidth:'15px',padding:"5px"}}
                onClick={
                  () => onDeleteAdminuser(params)
                }
              >
                <DeleteIcon style={{color:"#717E8B",fontSize:"16px"}} />
              </Button>
    
              {
                (params.row.password_create == false && params.row.auth_type == 0) &&
                <Button
                type="button"
                title="Reset Password"
                style={{border:"none",color:"#717E8B",minWidth:'15px',padding:"5px"}}
                onClick={
                  (event: any) => resendEmail(event, params)
                }
                >
                  <EmailIcon style={{color:"#717E8B",fontSize:"16px"}} />
                </Button>
              }
              
            </ButtonGroup>
          }
        },
      ];
      
      users.map((val: any) => {
        if(system_flagged == true){
          userFiled.push({
            id: val.user_id,
            active: val.active,
            auth_type: val.auth_type,
            deleted: val.deleted,
            first_name: val.first_name,
            last_name: val.last_name,
            mfa_enabled: val.mfa_enabled,
            middle_name: val.middle_name,
            role_id: val.role_id,
            user_id: val.user_id,
            user_locked: val.user_locked,
            username: val.username,
            password_create: val.password_create,
            experience: val.totalsessions,
            department_alias: (val.department && val.department.department_alias) ? val.department.department_alias : "",
            department_name: (val.department && val.department.department_name) ? val.department.department_name : "",
            enterprise_billing: (val.department && val.department.enterprise_billing) ? val.department.enterprise_billing : "",
            last_active: UtilService.getLocalDateTimeZone(val.last_login_at),
            system_flagged:val.system_flagged
          })
        }else {
          if(val.department_id == loginUserData.department_id){
          
            if(isuseradmin && isuseradmin[0].access_value){
              if(val.role_id == admin_roleid.role_id || val.role_id == creator_roleid.role_id ||  val.department_id == loginUserData.department_id){
                userFiled.push({
                  id: val.user_id,
                  active: val.active,
                  auth_type: val.auth_type,
                  deleted: val.deleted,
                  first_name: val.first_name,
                  last_name: val.last_name,
                  mfa_enabled: val.mfa_enabled,
                  middle_name: val.middle_name,
                  role_id: val.role_id,
                  user_id: val.user_id,
                  user_locked: val.user_locked,
                  username: val.username,
                  password_create: val.password_create,
                  experience: val.totalsessions,
                  department_alias: (val.department && val.department.department_alias) ? val.department.department_alias : "",
                  department_name: (val.department && val.department.department_name) ? val.department.department_name : "",
                  enterprise_billing: (val.department && val.department.enterprise_billing) ? val.department.enterprise_billing : "",
                  last_active: UtilService.getLocalDateTimeZone(val.last_login_at),
                  system_flagged:val.system_flagged
                })
              }
            }else if(isusertrialadmin && isusertrialadmin[0].access_value){
              if(val.role_id == loginUserData.role_id || subscriber_roleid.filter((v:any) => v.role_id == val.role_id)[0] || val.department_id == loginUserData.department_id){
                userFiled.push({
                  id: val.user_id,
                  active: val.active,
                  auth_type: val.auth_type,
                  deleted: val.deleted,
                  first_name: val.first_name,
                  last_name: val.last_name,
                  mfa_enabled: val.mfa_enabled,
                  middle_name: val.middle_name,
                  role_id: val.role_id,
                  user_id: val.user_id,
                  user_locked: val.user_locked,
                  username: val.username,
                  password_create: val.password_create,
                  experience: val.totalsessions,
                  department_alias: (val.department && val.department.department_alias) ? val.department.department_alias : "",
                  department_name: (val.department && val.department.department_name) ? val.department.department_name : "",
                  enterprise_billing: (val.department && val.department.enterprise_billing) ? val.department.enterprise_billing : "",
                  last_active: UtilService.getLocalDateTimeZone(val.last_login_at),
                  system_flagged:val.system_flagged
                })
              }
            }
          }
        }
      })
    }
    
    setNewcolumns(colsfields);
    setNewrows(userFiled);

  }, [users, roles]);

  useEffect(() => {
    const request = { customer_name: loginUserData.customer_name };
    dispatch(getAdminUsers(apolloClient.client, request));
    dispatch(getRoles(apolloClient.client, request));
  }, [apolloClient.client, dispatch, loginUserData.user_id]);

  const onSearchUser = (e: any) => {
    setSearchText(e.target.value);
    if (e.target.value.trim() && e.target.value.trim().length >= 3) { // there are inserted texts
      const req = { customer_name: loginUserData.customer_name, search: e.target.value.trim() };
      dispatch(getAdminUsers(apolloClient.client, req))
    }
    if(e.target.value == ""){
      const req = { customer_name: loginUserData.customer_name };
      dispatch(getAdminUsers(apolloClient.client, req))
    }
  };

  const clearSerach = () => {
    setSearchText("");
    const request = { customer_name: loginUserData.customer_name };
    dispatch(getAdminUsers(apolloClient.client, request));
  };
  
  const hideSnackAlert = () =>{
    setIsShownSnackAlert(false);
  }
  

  // on delete the user
  const onDeleteAdminuser = (value: any) => {
    setConfirmationDeletePage(true);
    setdeleteuser(value);
  }

  const deleteAdminUser = () => {
    const request = {customer_name: loginUserData.customer_name, username: deleteuserdata.username};
    dispatch(deletePermanentUser(apolloClient.client, request));
    setConfirmationDeletePage(false);
  }


  return (
    <>
      
        <div className={classes.root}>
          <div>
            <div style={{ maxHeight: `calc(100vh - 250px)`, width: "100%" }}>
              <Grid container style={{paddingTop:4, marginBottom:"10px"}}>
                <Grid item md={3} sm={3} xs={12} style={{textAlign:"left"}}>
                  <p className={classes.description}>Users</p>
                </Grid>
                <Grid item md={9} sm={9} xs={12} style={{marginLeft:"auto"}}>
                  <Grid container justifyContent="flex-end">
                    <Grid item>
                      <Button
                      variant="contained"
                      color="primary"
                      onClick={() => setShowModal(true)}
                      endIcon={<img
                        src={'/assets/icons/admin/project-add.svg'}
                        alt={'img'}
                      />}
                      > Add New </Button>
                    </Grid>
                    <Grid item>
                      <div style={{ marginLeft:"10px", paddingRight: 10, maxWidth:"191px" }}>
                        <TextField
                          className="inputRounded"
                          size="small"
                          variant="outlined"
                          style={{ color: '#697683', fontSize:"14px" }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <SvgIcon
                                  style={{fontSize:"14px"}}
                                  color="action"
                                >
                                  <SearchIcon />
                                </SvgIcon>
                              </InputAdornment>
                            ),
                            endAdornment: <InputAdornment position="end">
                              {searchText && <img
                                src={'/assets/icons/creatordashboard/remove.svg'}
                                alt={'icon'}
                                className={classes.icon}
                                onClick={() => clearSerach()}
                              />}
                            </InputAdornment>
                          }}

                          value={searchText}
                          onChange={(e) => onSearchUser(e)}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              {showModal && <UserModel open={showModal} onClose={closeModal} from="add" />}
              {showEditModal && <EditUserModel open={showEditModal} onClose={closeModal} userId={userId} firstName={firstName}  lastName={lastName} from="edit" />}
              
              {is_loading ?
                <Loading />
              :
                <AdminTable 
                  columns={columns} 
                  rows={newrows} 
                  roles={roles}
                  editUserDetail={(row: any)=>editUserDetail(row)} 
                  onDeleteAdminuser={(row: any)=>onDeleteAdminuser(row)} 
                  resendEmail={(event: any, row: any)=>resendEmail(event, row)} 
                  handleChangeRole={(event: any, row: any)=>handleChangeRole(event, row)} 
                />
              }
            </div>
          </div>
          {showViewModal && (<ViewUser open={showViewModal} onClose={closeModal} />)}
        </div>

      <Dialog
        fullWidth={true}
        maxWidth={'xs'}
        open={confirmationDeletePage?true:false}
        classes={{
          paper: classes.tagmodalwrap
        }}
        onClose={() => {setConfirmationDeletePage(false)}}
      >
        <DialogTitle>
        {"Delete User?"}
        </DialogTitle>
        <Divider />
        <DialogContent style={{ paddingLeft: 0, paddingRight: 0 }}>
            <Container maxWidth="md">
              <Typography className={classes.delemaildesc}>This will completely remove this user from entire system and lose all information.</Typography>
            </Container>
          </DialogContent>
        <Box mt={3} mb={3} mr={2} display='flex' justifyContent='flex-end'>
          <Button variant="contained" size='small' onClick={()=>setConfirmationDeletePage(false)} className={classes.modalBtn}>
            NO
          </Button>
          <Button color='primary' size='small' variant="contained" onClick={()=>deleteAdminUser()}  className={classes.modalBtn}>
            YES
          </Button>
        </Box>
      </Dialog>
      <CustomSnackBar type={snackAlertType} message={snackAlertMsg} open={isShownSnackAlert} onClose={hideSnackAlert} />
    </>
  );
}
